export default __webpack_public_path__ + "static/media/fruit & veg_cat_disabled.5025594d.png";